module.exports = __webpack_public_path__ + "static/stool1-0b692b3f38f90b92e7a91e87018e5654.jpg";